import { render } from "./TransactionWidget.vue?vue&type=template&id=2af707c6&scoped=true"
import script from "./TransactionWidget.vue?vue&type=script&lang=js"
export * from "./TransactionWidget.vue?vue&type=script&lang=js"

import "./TransactionWidget.vue?vue&type=style&index=0&id=2af707c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af707c6"],['__file',"src/views/Dashboard/TransactionWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2af707c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2af707c6', __exports__)) {
    api.reload('2af707c6', __exports__)
  }
  
  module.hot.accept("./TransactionWidget.vue?vue&type=template&id=2af707c6&scoped=true", () => {
    api.rerender('2af707c6', render)
  })

}


export default __exports__